<script>
    import Header from "../header.svelte"

    let is_busy = false;
    let content_title = "Expense Review"
</script>

<Header title="{content_title}" bind:is_busy={is_busy} />

<div class="contentholder">


 
    
</div>


<style>
    .contentholder {
        width: 100%;
    }

    .section_old {
        width: 100%;
    }

    .section_old .sectiontitle_old i{
        width: 25px;
        display: none;

    }
    .section_old .sectionsubtitle_old {
        width: 100%;
        margin-top: 10px;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
        color: white;
        background-color: #1769aa;
        padding: 5px;
        box-sizing: border-box;
    }

     .exportbuttonbar {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
    }
     .exportbuttonbar button {
        max-width: 300px;
        width: 100%;
        background-color: #ff9100;
        color: white;
     } 

     .addexpensebuttonbar {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
     }
     .addexpensebuttonbar button {
        max-width: 300px;
        width: 100%;
        background-color: #357a38;
        color: white;
     } 

     .newexpensebuttonholder {
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: start;
     }

     .newexpensebuttonholder button{
        max-width: 300px;
        width: 100%;
     }

     .newexpensebuttonholder button.savebutton{
         background-color: #1c54b2;
         color: white;
     }

     .newexpensebuttonholder button.cancelbutton{
        background-color: #b2102f;
        color: white;
     }

     .newitembuttonholder {
        margin-left: 10px;
        width: 40%;
        display: flex;
        flex-direction: row;
        justify-content: start;
        align-items: center;
    }

    .newitembuttonholder button{
        max-width: 100px;
        width: 100%;
        height: 40px;
    }

    .newitembuttonholder button.savebutton{
        color: #1c54b2;
        background-color: white;
     }

    .newitembuttonholder button.cancelbutton{
        color: #b2102f;
        background-color: white;
    }

    :global(.rowwrap .group) {
        min-width: 300px;
        max-width: 300px;
    }

    .toolsholder {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        box-sizing: border-box;
    }

    :global(.toolsholder .group) {
        padding-left: 10px;
        padding-right: 10px;
    }


    .showmobile {
        display: none !important;
    }
    .showdesktop {
        display: block !important;        
    }
    .highlight {
        border: 1px solid black;
        padding: 10px;
        box-sizing: border-box;
    }

    @media (max-device-width: 1024px), (max-width: 1023px) {
        .contentholder {
            padding: 0px;
            width: 100%;
            max-width: 100vw;
            margin-left: auto;
            margin-right: auto;
        }
        .section_old {
            padding: 0px;
        }
        .toolsholder {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        :global(.toolsholder .group) {
            padding-left: 0px;
            padding-right: 0px;
        }


        .exportbuttonbar {
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
        }
        .exportbuttonbar button {
            max-width: 100%;
            width: 100%;
            background-color: #ff9100;
            color: white;
        } 

        .addexpensebuttonbar {
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .addexpensebuttonbar button {
            max-width: 100%;
            width: 100%;
            background-color: #357a38;
            color: white;
        } 

        .newexpensebuttonholder {
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
            justify-content: start;
        }

        .newexpensebuttonholder button{
            max-width: 100%;
            width: 100%;
        }

        .newitembuttonholder {
            margin-left: 0px;
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
        }

        .newitembuttonholder button{
            max-width: 100%;
            width: 100%;
            height: 40px;
        }

        :global(.rowwrap .group) {
            min-width: 100%;
            max-width: 100%;
        }


        .showmobile {
            display: block !important;
        }
        .showdesktop {
            display: none !important;        
        }

    }

</style>